import styled from '@emotion/styled'
import { css } from '@emotion/react'

import type { Theme } from 'scripts/react-components/themes/Theme'

const alertWrapperStyles = ({ theme }: Theme) => css`
  label: alert-wrapper;

  > div {
    & span {
      margin-right: ${theme.spacings.byte};
    }

    & div {
      display: inline;
      white-space: normal;
    }

    & p {
      color: ${theme.colors.n900};
    }

    display: flex;
    border-radius: ${theme.borderRadius.giga};
    padding: ${theme.spacings.kilo};
    background-color: ${theme.colors.v100};
  }
`

export const AlertWrapper = styled('div')(alertWrapperStyles)
